module.exports = __webpack_public_path__ + "static/media/unknown.db5ff640.svg";